var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequesteditems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "requested-items-svg",
    d: "M12.0002 12.0868V15.5154L13.7145 16.3726M15.4287 4.37256V6.19636M15.4287 6.19636V7.80113M15.4287 6.19636C14.6221 6.08684 13.5674 6.08684 12.0002 6.08684C10.4329 6.08684 9.37823 6.08684 8.5716 6.19636M15.4287 6.19636C15.8554 6.2543 16.2127 6.34288 16.5397 6.47832C17.7998 7.00029 18.801 8.00147 19.323 9.26162C19.7145 10.2067 19.7145 11.4049 19.7145 13.8011C19.7145 16.1974 19.7145 17.3955 19.323 18.3406C18.801 19.6008 17.7998 20.602 16.5397 21.1239C15.5946 21.5154 14.3964 21.5154 12.0002 21.5154C9.6039 21.5154 8.40577 21.5154 7.46066 21.1239C6.20052 20.602 5.19933 19.6008 4.67737 18.3406C4.28589 17.3955 4.28589 16.1974 4.28589 13.8011C4.28589 11.4049 4.28589 10.2067 4.67737 9.26162C5.19933 8.00147 6.20052 7.00029 7.46066 6.47832C7.78764 6.34288 8.14491 6.2543 8.5716 6.19636M8.5716 4.37256V6.19636M8.5716 6.19636V7.80113",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b-requested-items-svg",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#requested-items-svg"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#requested-items-svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#b-requested-items-svg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequesteditems);
export default __webpack_public_path__ + "static/media/requesteditems.39694fa728ca36f5f6cc8733e5f68e98.svg";
export { ForwardRef as ReactComponent };